<template>
  <form>
    <div class="form-group">
      <label for="password">{{ $t('authentification.password') }}</label>
      <input v-model="password" v-validate="'password|required'" class="form-control" name="password" id="password" type="password" :placeholder="$t('authentification.password')">
      <span class="text-danger" v-if="errors.has('password')">{{$t('authentification.passwordPolicy')}}</span>
    </div>
    <div class="form-group">
      <label for="inputPasswordConfirmation">{{ $t('authentification.confirmPassword') }}</label>
      <input v-model="passwordConfirmation"  v-validate="'required|confirmed:password'" data-vv-as="password" class="form-control" name="inputPasswordConfirmation" id="inputPasswordConfirmation" type="password" :placeholder="$t('authentification.confirmPassword')">
      <span class="text-danger" v-if="errors.has('inputPasswordConfirmation')">{{$t('authentification.confirmPasswordError')}}</span>
    </div>
    
    <a @click="confirm" href="#" class="btn btn-primary">{{$t('form.confirm_button')}}</a>
  </form>
</template>

<script>
export default {
  name: 'password-input',
  data() {
    return {
      password: '',
      passwordConfirmation: '',
    }
  },
  props: ['action'],
  created: function() {},
  methods: {
    confirm: function() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.action(clean => {
            this.password = ''
            this.passwordConfirmation = ''
            this.$validator.reset()
          })
        }
      })
    },
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>

</style>



// WEBPACK FOOTER //
// src/shared/components/PasswordInput.vue